export default __webpack_public_path__ + "static/media/959.a02f9bc8.png";